<template>
  <div class="qualitycheck-list">
    <Toolbar :handle-add="addHandler" v-if="userHasAccess('qualitycheck_edit')"/>

    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <h1><v-icon large>mdi-bug-check</v-icon>{{$t('qualitycheck.qualitycheck.checks')}}</h1>
        </v-flex>
        <v-flex lg12>
          <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
            <QualityCheckFilterForm
              ref="filterForm"
              :values="filters"
              slot="filter"
            />
          </DataFilter>

          <br />

          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
  :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
            :loading="isLoading"
            :loading-text="$t('global.loading')"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            item-key="@id"
            @update:options="onUpdateOptions"
@click:row="showHandler"
@contextmenu:row="showHandlerExt"
          >
                <template slot="item.start" slot-scope="{ item }">
                  {{ formatDate(item['start'], 'long') }}
                </template>
                <template slot="item.end" slot-scope="{ item }">
                  {{ formatDate(item['end'], 'long') }}
                </template>
                <template slot="item.success" slot-scope="{ item }">
                  <span v-if="item['success']"  ><v-icon color="green">mdi-check-circle</v-icon></span>
                  <span v-else><v-icon color="red">mdi-close-circle</v-icon></span>
                </template>

            <ActionCell
              slot="item.action"
              slot-scope="props"
              :handle-show="() => showHandler(props.item)"
            ></ActionCell>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import ActionCell from '../../components/ActionCell';
import QualityCheckFilterForm from '../../components/qualitycheck/Filter';
import DataFilter from '../../components/DataFilter';
import Toolbar from '../../components/Toolbar';
import AccessMixin from '../../mixins/AccessMixin';

export default {
  name: 'QualityCheckList',
  servicePrefix: 'QualityCheck',
  mixins: [ListMixin,AccessMixin],
  components: {
    Toolbar,
    ActionCell,
    QualityCheckFilterForm,
    DataFilter
  },
  data() {
    return {
      headers: [
        { text: this.$t('qualitycheck.qualitycheck.product'), value: 'product.name' },
        { text: this.$t('qualitycheck.qualitycheck.name'), value: 'name' },
        { text: this.$t('qualitycheck.qualitycheck.usertesting'), value: 'userTesting.login' },
        { text: this.$t('qualitycheck.qualitycheck.start'), value: 'start' },
        { text: this.$t('qualitycheck.qualitycheck.end'), value: 'end' },
        { text: this.$t('qualitycheck.qualitycheck.success'), value: 'success' },

        {
          text: this.$t('global.actions'),
          value: 'action',
          sortable: false
        }
      ],
      selected: [],
footer: {
  'itemsPerPageText': "",
},
      options: {sortBy : ['start'], sortDesc : [true]}
    };
  },
  computed: {
    ...mapGetters('qualitycheck', {
      items: 'list'
    }),
    ...mapFields('qualitycheck', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('qualitycheck', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    })
  }
};
</script>
